import { apiCall } from "../../../../../_utils";
import { apiUrls } from "../../../../../_constants";

export const draftService = {
  getAllInstructorDraft,
  addInstructor,
  getInstructor,
  deleteDraft
};

function getAllInstructorDraft(params) {
  return apiCall("GET", `${apiUrls.posts.draft}`, null, params);
}

function addInstructor(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.instructors.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getInstructor(id) {
  return apiCall("GET", `${apiUrls.instructors.base}/${id}`);
}

function deleteDraft(id) {
  return apiCall("DELETE", `${apiUrls.posts.base}/${id}`);
}
